import { Id } from "@dgs/core";

export const productDeploymentKeys = {
	index: ["deployment"],
	details: (productId: Id) => [...productDeploymentKeys.index, `${productId}`],
};
